export default (number) => typeof number === 'number' && !Number.isNaN(number);
